import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/organization").then((module) => ({
    default: module.OrganizationPage,
  })),
);

export const Route = createFileRoute("/admin/organizations/$orgId")({
  component: Page,
});
